__turbopack_context__.v({
  "RichTextBlock": "FsX04G_RichTextBlock",
  "RichTextBlock__inner": "FsX04G_RichTextBlock__inner",
});
